/**
 * IXstone Scroll Reveal - Lightweight animation framework (~2KB)
 * Handles: reveal animations, stagger, counter animations, parallax hero
 * Respects prefers-reduced-motion
 */
(function () {
  "use strict";

  var prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  // ── Reveal Animations (IntersectionObserver) ──────────────────
  var revealElements = document.querySelectorAll("[class*='reveal-']");
  if (revealElements.length && !prefersReducedMotion) {
    var revealObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;

          // Stagger: check parent for data-stagger
          var parent = el.parentElement;
          var staggerMs = parent ? parseInt(parent.getAttribute("data-stagger") || "0", 10) : 0;
          if (staggerMs > 0) {
            var siblings = Array.from(parent.querySelectorAll("[class*='reveal-']"));
            var index = siblings.indexOf(el);
            var delay = Math.min(index * staggerMs, 800); // cap at 800ms
            el.style.transitionDelay = delay + "ms";
          }

          el.classList.add("revealed");
          revealObserver.unobserve(el);
        });
      },
      { threshold: 0.15, rootMargin: "0px 0px -40px 0px" }
    );

    revealElements.forEach(function (el) {
      revealObserver.observe(el);
    });
  } else if (prefersReducedMotion) {
    // Show all immediately
    revealElements.forEach(function (el) {
      el.classList.add("revealed");
    });
  }

  // ── Counter Animations ────────────────────────────────────────
  var counters = document.querySelectorAll(".counter-animate");
  if (counters.length && !prefersReducedMotion) {
    var counterObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          counterObserver.unobserve(el);

          var target = parseInt(el.getAttribute("data-target") || "0", 10);
          var suffix = el.getAttribute("data-suffix") || "";
          var separator = el.getAttribute("data-separator") || ".";
          var duration = 2000;
          var startTime = null;

          function formatNumber(n) {
            return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator);
          }

          function animate(timestamp) {
            if (!startTime) startTime = timestamp;
            var progress = Math.min((timestamp - startTime) / duration, 1);
            // Ease-out deceleration
            var eased = 1 - Math.pow(1 - progress, 3);
            var current = Math.round(eased * target);
            el.textContent = formatNumber(current) + suffix;

            if (progress < 1) {
              requestAnimationFrame(animate);
            } else {
              el.textContent = formatNumber(target) + suffix;
              el.setAttribute("aria-live", "polite");
            }
          }

          el.setAttribute("aria-live", "off");
          requestAnimationFrame(animate);
        });
      },
      { threshold: 0.5 }
    );

    counters.forEach(function (el) {
      counterObserver.observe(el);
    });
  } else {
    // No animation: show final value immediately
    counters.forEach(function (el) {
      var target = el.getAttribute("data-target") || "0";
      var suffix = el.getAttribute("data-suffix") || "";
      var separator = el.getAttribute("data-separator") || ".";
      el.textContent = target.replace(/\B(?=(\d{3})+(?!\d))/g, separator) + suffix;
    });
  }

  // ── Parallax Hero ─────────────────────────────────────────────
  var heroEl = document.querySelector(".lf-hero__bg");
  if (heroEl && !prefersReducedMotion) {
    var ticking = false;
    function updateParallax() {
      var scrollY = window.scrollY || window.pageYOffset;
      var maxShift = 60;
      var heroHeight = heroEl.parentElement ? heroEl.parentElement.offsetHeight : 600;
      if (scrollY < heroHeight) {
        var shift = Math.min(scrollY * 0.3, maxShift);
        heroEl.style.transform = "translateY(" + shift + "px)";
      }
      ticking = false;
    }

    window.addEventListener("scroll", function () {
      if (!ticking) {
        requestAnimationFrame(updateParallax);
        ticking = true;
      }
    }, { passive: true });
  }
})();
